import '@/features/notifications/background-init'
import 'expo-router/entry'
